import { CellClickedEvent } from 'ag-grid-community';
import { FarmIcon } from 'assets/img/icons';
import { ITab } from 'DesignSystem/Primitives/Tabs/Tabs';
import React, { memo } from 'react';
import {
  EDataImportCategories,
  TFarmColumns,
  ITableSettings,
} from 'FeatureModules/DataImport/types/dataImport.types';
import CropCellEditor from '../Components/DataImportTable/CellEditors/CropCellEditor';
import DropdownCellRenderer from '../Components/DataImportTable/CellRenderers/DropdownCellRenderer';
import { TColDefWithValidator } from '../Components/DataImportTable/excelTable.types';
import HeaderColumn from '../Components/DataImportTable/HeaderColumn';
import { createColumnDefinition } from './dataImport.utils';
import {
  createPositiveFloatValidator,
  validateGeometry,
  validateNotEmpty,
  validateNotEmptyAndCrop,
  validateUniqueness,
} from './dataImport.validators';

interface IDataImportCategoryConfig {
  key: EDataImportCategories;
  dataLabel: string;
  tab: ITab;
  getColumnDefinitions: (settings: ITableSettings) => TColDefWithValidator<TFarmColumns>[];
}

const startEditingCell = (event: CellClickedEvent) => {
  const colId = event.column.getColId();

  if (event.rowIndex !== null && colId) {
    event.api.startEditingCell({
      rowIndex: event.rowIndex,
      colKey: colId,
    });
  }
};

export const DATA_IMPORT_CATEGORY_CONFIG: IDataImportCategoryConfig[] = [
  {
    key: EDataImportCategories.Farms,
    tab: {
      key: EDataImportCategories.Farms,
      label: 'Farms',
      startIcon: <FarmIcon height={12} />,
    },
    dataLabel: 'farm',
    getColumnDefinitions: settings => [
      createColumnDefinition('farmId', () => <HeaderColumn title="Farm ID" />, validateUniqueness),
      createColumnDefinition('name', () => <HeaderColumn title="Name" />, validateNotEmpty),
      createColumnDefinition(
        'crop',
        () => <HeaderColumn title="Focus crop" />,
        validateNotEmptyAndCrop,
        DropdownCellRenderer,
        {
          cellEditor: memo(CropCellEditor),
          onCellClicked: startEditingCell,
        }
      ),
      createColumnDefinition(
        'location',
        () => {
          const subtitle = `(${
            settings.coordinatesVersion === 'latlng' ? 'Lat, Lng' : 'Lng, Lat'
          })`;
          return <HeaderColumn title="Location" subtitle={subtitle} />;
        },
        validateGeometry
      ),
      createColumnDefinition(
        'farmSize',
        () => {
          const subtitle = `(${settings.farmSizeUnit === 'ha' ? 'Hectares' : 'km²'})`;
          return <HeaderColumn title="Farm size" subtitle={subtitle} />;
        },
        createPositiveFloatValidator('Farm size needs to be a number, in e.g. hectares.')
      ),
      createColumnDefinition('description', () => <HeaderColumn title="Description" />),
    ],
  },
];
